module.exports = __webpack_public_path__ + "img/vertebrates.e4220f8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vertebrates.jpg
// module id = j5l0
// module chunks = 0